<template>
  <div>
    <a-tabs v-model="queryForm.date" size="small" @change="getdata()">
      <a-tab-pane v-for="item in dates" :key="item" :tab="item"></a-tab-pane>
      <a-button slot="tabBarExtraContent" type="primary" @click="showdownloadtask">
        导出派车任务
      </a-button>
    </a-tabs>
    <v-card tile>
      <a-input-search placeholder="输入车牌号，回车自动定位到结果行并高亮" enter-button @input="onInput" @search="onSearch" />
      <div class="d-flex justify-space-between pa-1">
        <a-space>
          <v-btn color="primary" tile small @click="getdata()">刷新</v-btn>
        </a-space>
        <a-space>
          <v-btn color="primary" tile small @click="showresult()">调车计划</v-btn>
        </a-space>
      </div>
      <a-table size="small" bordered :columns="headers" :data-source="list" :pagination="false" tableLayout="fixed"
        :locale="{ emptyText: '暂无数据' }" :scroll="{ x: width, y: height }" row-key="_id" :customRow="(record) => {
          let opts = {
            className: record.markColor || '',
          };
          if (record._type === 'item' && matchids.includes(record._id)) {
            opts.className = 'highlight';
          }
          if (record._type === 'vehicle') {
            opts.className = 'vehicle';
          }
          return opts;
        }" ref="tableRef" @scroll="handleScroll">
        <!--排序-->
        <template slot="A" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            <p>{{ record.index }}</p>
          </template>
        </template>
        <!--排序-->
        <template slot="B" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            <p>{{ record.area }}</p>
          </template>
        </template>
        <!--始发地-->
        <template slot="C" slot-scope="text, record">
          <span v-if="record._type === 'header'" class="error--text font-weight-bold">
            {{ record.header }}
          </span>
          <template v-else-if="record._type === 'item'">
            {{ record.departure }}
          </template>
        </template>
        <!--卸货地-->
        <template slot="D" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            {{ record.destination }}
          </template>
        </template>
        <!--车牌号-->
        <template slot="F" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            {{ record.vehicle_number || '--' }}
          </template>
          <span v-else-if="record._type === 'header'" class="error--text font-weight-bold">
            {{ record.vcount }}
          </span>
        </template>
        <!--挂厢号-->
        <template slot="G" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            {{ record.vehicle_gnumber || '--' }}
          </template>
          <span v-else-if="record._type === 'header'" class="error--text font-weight-bold">
            {{ record.gcount }}
          </span>
        </template>
        <!--车型-->
        <template slot="H" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            {{ record.vehicle_type }}
          </template>
        </template>
        <!--司机-->
        <template slot="I" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            {{ record.driver || '--' }}
          </template>
        </template>
        <!--运价-->
        <template slot="J" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            {{ record.price || '--' }}
          </template>
        </template>
        <!--蜂羽-->
        <template slot="K" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            <template v-if="record.platform_state">
              <template v-for="item in task_states">
                <span v-if="record.platform_state === item.value" :key="item.value" :style="{
                  'color': $utils.textToBgColor(item.label)
                }">{{ item.label }}</span>
              </template>
            </template>
            <template v-else>--</template>
          </template>
        </template>
        <!--任务名称-->
        <template slot="L" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            {{ record.name || '--' }}
          </template>
        </template>
        <!--车辆状态-->
        <template slot="M" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            {{ record.vehiclestate || '--' }}
          </template>
        </template>
        <!--中邮任务-->
        <template slot="N" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            <template v-if="record.task_state">
              <template v-for="item in task_states">
                <span v-if="record.task_state === item.value" :key="item.value" :style="{
                  'color': $utils.textToBgColor(item.label)
                }">{{ item.label }}</span>
              </template>
            </template>
            <template v-else>--</template>
          </template>
        </template>
        <!--派车单号-->
        <template slot="O" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            {{ record.dispatch_no || '--' }}
          </template>
        </template>
        <!--GPS状态-->
        <template slot="P" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            <template v-if="record.gps_state === 0">
              {{ record.gps_no || '--' }}
            </template>
            <template v-else>
              <template v-for="item in gps_states">
                <span v-if="record.gps_state === item.value" :key="item.value" :style="{
                  'color': $utils.textToBgColor(item.label)
                }">{{ item.label }}</span>
              </template>
            </template>
          </template>
        </template>
        <!--调车人-->
        <template slot="Q" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            {{ record.dispatch_name || '--' }}
          </template>
        </template>
        <!--套牌号-->
        <template slot="S" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            {{ record.vehicle_onumber }}
          </template>
        </template>
        <!--备注-->
        <template slot="T" slot-scope="text, record">
          <template v-if="record._type === 'item'">
            {{ record.remark }}
          </template>
        </template>
      </a-table>
    </v-card>
    <DispatchResult ref="dispatchresultRef" />
    <DownloadTask ref="downloadtaskRef" modelTitle="导出派车任务" downloadType="dispatchplanv2" />
  </div>
</template>

<script>
import _ from "underscore";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { mapState } from "vuex";
import DispatchResult from './dispatch/result.vue';
import DownloadTask from '@/components/downloadtask.vue';
export default {
  name: "Dispatchplan98",
  data() {
    return {
      locale,
      queryForm: {
        groupid: 98,
        date: this.$moment().format('YYYY-MM-DD'),
      },
      groups: [],
      dates: [
        this.$moment().add(-3, 'day').format('YYYY-MM-DD'),
        this.$moment().add(-2, 'day').format('YYYY-MM-DD'),
        this.$moment().add(-1, 'day').format('YYYY-MM-DD'),
        this.$moment().add(0, 'day').format('YYYY-MM-DD'),
        this.$moment().add(1, 'day').format('YYYY-MM-DD'),
        this.$moment().add(2, 'day').format('YYYY-MM-DD'),
        this.$moment().add(3, 'day').format('YYYY-MM-DD'),
      ],
      headers: [
        { dataIndex: "A", scopedSlots: { customRender: "A" }, width: 80, align: "center", title: "#", },
        { dataIndex: "B", scopedSlots: { customRender: "B" }, width: 100, align: "center", title: "区域", },
        { dataIndex: "C", scopedSlots: { customRender: "C" }, width: 80, align: "center", title: "始发地", },
        { dataIndex: "D", scopedSlots: { customRender: "D" }, width: 90, align: "center", title: "卸货地", },
        { dataIndex: "F", scopedSlots: { customRender: "F" }, width: 120, align: "center", title: "车牌号*", },
        { dataIndex: "G", scopedSlots: { customRender: "G" }, width: 120, align: "center", title: "挂厢号*", },
        { dataIndex: "H", scopedSlots: { customRender: "H" }, width: 50, align: "center", title: "车型", },
        { dataIndex: "I", scopedSlots: { customRender: "I" }, width: 200, align: "center", title: "司机*", },
        { dataIndex: "J", scopedSlots: { customRender: "J" }, width: 80, align: "center", title: "运价*", },
        { dataIndex: "K", scopedSlots: { customRender: "K" }, width: 80, align: "center", title: "蜂羽", },
        { dataIndex: "L", scopedSlots: { customRender: "L" }, width: 125, align: "center", title: "任务名称", },
        { dataIndex: "M", scopedSlots: { customRender: "M" }, width: 100, align: "center", title: "车辆状态", },
        { dataIndex: "N", scopedSlots: { customRender: "N" }, width: 80, align: "center", title: "中邮任务", },
        { dataIndex: "O", scopedSlots: { customRender: "O" }, width: 120, align: "center", title: "派车单号*", },
        { dataIndex: "P", scopedSlots: { customRender: "P" }, width: 80, align: "center", title: "GPS状态", },
        { dataIndex: "dispatch_price", scopedSlots: { customRender: "dispatch_price" }, width: 100, align: "center", title: "调车参考价", },
        { dataIndex: "Q", scopedSlots: { customRender: "Q" }, width: 100, align: "center", title: "调车人*", },
        { dataIndex: "S", scopedSlots: { customRender: "S" }, width: 120, align: "center", title: "套牌号", },
        { dataIndex: "T", scopedSlots: { customRender: "T" }, width: 150, align: "center", title: "备注", },
      ],
      list: [],
      height: 600,
      vrules: {
        required: (value) => !!value || "不能为空",
      },
      vehicle_states: [],
      gps_states: [],
      task_states: [],
      matchids: [],
      matchindex: -1,
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
  },
  components: { DispatchResult, DownloadTask },
  watch: {},
  mounted() {
    this.height = window.innerHeight - 300;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 300;
    };
    this.list = [];
  },
  activated() {
    this.dates = [
      this.$moment().add(-3, 'day').format('YYYY-MM-DD'),
      this.$moment().add(-2, 'day').format('YYYY-MM-DD'),
      this.$moment().add(-1, 'day').format('YYYY-MM-DD'),
      this.$moment().add(0, 'day').format('YYYY-MM-DD'),
      this.$moment().add(1, 'day').format('YYYY-MM-DD'),
      this.$moment().add(2, 'day').format('YYYY-MM-DD'),
      this.$moment().add(3, 'day').format('YYYY-MM-DD'),
    ];
    this.getdata();
  },
  methods: {
    init(v) {
      this.queryForm.groupid = v;
      this.getdata();
    },
    showresult() {
      this.$refs.dispatchresultRef.init(this.queryForm);
    },
    getdata(payload) {
      if (payload?.hideloading !== true) {
        this.$toast.loading({ message: "" });
      }
      this.$api.doAPI("/dispatchplan/v2/list", this.queryForm).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.groups = res.data.groups;
          this.dates = res.data.dates;
          this.vehicle_states = res.data.vehicle_states;
          this.gps_states = res.data.gps_states;
          this.task_states = res.data.task_states;
          this.makedata(res.data);
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    onInput(e) {
      let value = e.data;
      console.log('onInput', value);
      if (!value) {
        this.matchids = [];
        this.matchindex = -1;
        this.scrollToRow("");
      }
    },
    onSearch(value) {
      console.log('onSearch', value);
      this.matchids = this.list.filter(n => {
        if (value) {
          return (
            (
              n.vehicle_number && n.vehicle_number.includes(value)
            )
            // ||
            // (
            //   n.driver && n.driver.includes(value)
            // )
          )
        }
        return false;
      }).map(n => n._id);
      if (this.matchids.length > 0) {
        this.matchindex++;
        if (this.matchindex > this.matchids.length - 1) {
          this.matchindex = 0;
        }
        this.scrollToRow(this.matchids[this.matchindex]);
      }
      else {
        this.matchindex = -1;
        this.scrollToRow("");
      }
    },
    scrollToRow(_id) {
      const row = this.list.find(n => n._id === _id);
      const tableBody = this.$refs.tableRef.$el.querySelector('.ant-table-body');
      if (row) {
        if (tableBody) {
          const rowElement = tableBody.querySelector(`[data-row-key="${row._id}"]`);
          if (rowElement) {
            const tableBodyScrollTop = rowElement.offsetTop - tableBody.offsetTop;
            tableBody.scrollTop = tableBodyScrollTop;
            return;
          }
        }
      }
      tableBody.scrollTop = 0;
    },
    handleScroll() {
      console.log('handleScroll');
      this.matchindex = -1;
    },
    ispassday() {
      return new Date(`${this.queryForm.date} 00:00:00.000+08:00`).getTime() < this.$dayjs().startOf('day').valueOf();
    },
    makedata({ list, groups }) {
      let headers = [];
      for (let group of groups) {
        headers.push(...group.headers);
      }
      headers = _.uniq(headers).filter(n => list.some(m => m.header === n && m.vehicle_number));
      let result = [];
      let index = 0;
      for (let header of headers) {
        let items = list.filter(n => n.header === header);
        let vlist = [];
        let vcount = 0;
        let gcount = 0;
        for (let item of items) {
          if (item.vehicle_number) {
            index++;
            vcount++;
            if (item.vehicle_gnumber) {
              gcount++;
            }
            let group = groups.find(n => n.value === item.groupid);
            vlist.push({
              _type: 'item',
              ...item,
              area: group.text,
              index,
            });
          }
        }
        result.push(
          {
            _type: 'header',
            header,
            count: vlist.length,
            vcount,
            gcount,
          },
          ...vlist,
        );
      }
      this.list = result;
    },
    showdownloadtask() {
      this.$refs.downloadtaskRef.reset();
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

/deep/ .ant-table-small>.ant-table-content>.ant-table-fixed-left>.ant-table-body-outer>.ant-table-body-inner>table>.ant-table-tbody>tr>td {
  padding: 0;
}

/deep/ .ant-table-small>.ant-table-content>.ant-table-scroll>.ant-table-body>table>.ant-table-tbody>tr>td {
  padding: 0;
}

/deep/ .highlight {
  background-color: #FFEB9C;
  color: red;
}

/deep/ .vehicle {
  background-color: rgba(255, 0, 0, 0.1);
}

/deep/ .new_created {
  background-color: #FFC7CE;
}

/deep/ .line0 {
  background-color: #DDEBF7;
}

/deep/ .line1 {
  background-color: #BDD7EE;
}

/deep/ .line2 {
  background-color: #9DC3E6;
}

/deep/ .line3 {
  background-color: #E2EFDA;
}

/deep/ .line4 {
  background-color: #C6E0B4;
}

/deep/ .line5 {
  background-color: #FFF2CC;
}

/deep/ .line6 {
  background-color: #FFE699;
}

/deep/ .line7 {
  background-color: #FCE4D6;
}

/deep/ .line8 {
  background-color: #FCE4EC;
}

/deep/ .line9 {
  background-color: #E8DAEF;
}

p {
  margin: 0;
}
</style>